import { Col } from "react-bootstrap";
import { IconType } from "react-icons";
import { RiArrowRightSLine } from "react-icons/ri";
import { Link } from "react-router-dom";
const EcitationAdminCard = (props: {
  link?: string;
  // icon: React.ReactElement<IconType>;
  title: string;
  hide?: boolean;
  onClick?: () => void;
  onCardClick?:()=> void;
}) => {
  if (props.hide) {
    return null;
  }
  if (props.link) {
    return (
      <Col md={3}>
        <Link to={props.link} className="main-link" onClick={props.onCardClick}>
          <div className="card-box shadow">
            <div className="card">
              <div className="card-inner">
                <div className="card-icon"> 
                <img
                    src={require("../../assets/eCitationAdmin.png")}width="40px" height='40px'  alt="eCitationAdmin"
                  /></div>
                <div className="card-text">
                  <h2 className="h5 mb-0">{props.title}</h2>
                </div>
              </div>
              <div className="card-next">
                <RiArrowRightSLine />
              </div>
            </div>
          </div>
        </Link>
      </Col>
    );
  }
  return (
    <Col md={3}>
      <span className="main-link" onClick={props.onClick}>
        <div className="card-box shadow">
          <div className="card">
            <div className="card-inner">
              <div className="card-icon"> 
               <img
                    src={require("../../assets/eCitationAdmin.png")}width="40px" height='40px'  alt="eCitationAdmin"
                  />
                  </div>
              <div className="card-text">
                <h2 className="h5 mb-0">{props.title}</h2>
              </div>
            </div>
            <div className="card-next">
              <RiArrowRightSLine />
            </div>
          </div>
        </div>
      </span>
    </Col>
  );
};
export default EcitationAdminCard;
